export const LOADER_GRAPH: { [key: string]: LOADER_GRAPH_TYPES} = {
  LINE_1: 'line1',
  LINE_2: 'line2',
  LINE_3: 'line3',
  COLUMN_1: 'column1',
  SEMICIRCLE: 'semicircle',
};

export type LOADER_GRAPH_TYPES = 'line1' | 'line2' | 'semicircle' | 'column1' | 'line3';